import { AfterViewInit, ChangeDetectorRef, Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { catchError, throwError } from 'rxjs';
import { UserDetailsService } from 'src/app/service/user-details.service';
import { animate, style, transition, trigger } from '@angular/animations';
import { Transform } from 'stream';
// import { RateDerivativesService } from 'src/app/service/rate-derivatives.service';

import { config } from 'src/app/config/config';


import { UserDetails } from 'src/app/entity/user-details';
import { PNoteService } from 'src/app/service/pnote.service';
// import { ForexDerivativesService } from 'src/app/service/forex-derivatives.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { AppService } from 'src/app/service/app.service';
import { CarouselConfig } from 'ngx-bootstrap/carousel';
declare var $: any;


@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css']
})
export class DashboardComponent implements OnInit {
  user: any = { menusList: [] };
  config: any = config;
  private userDetails: UserDetails;
  dashboardView: any[] = [];
  tradeData: any = [];
  pnoteChartData = [];
  crntYear: any = new Date().getFullYear();

  currentIndex: number = 0;
  itemsPerPage: number = 5;
  entityType: String;
  entityCode: String;
  memberData: any = [];
  selectedMember: any = "";

  pnoteview: [number, number] = [800, 400];
  irsView: [number, number] = [1000, 400];
  // irsChartOptions: any = {
  //   gradient: true,
  //   showLegend: true,
  //   showLabels: true,
  //   isDoughnut: false,
  //   legendPosistion: 'right',
  //   tradeDetailsColorScheme: {
  //     name: 'pieChart',
  //     selectable: true,
  //     // group: ScaleType.Ordinal,
  //     // domain: ['#392E7D', '#615997', '#8881B0', '#AFAACA', '#D8D4E4', '#E1E1E1', '#C5C4C4', '#A6A7A8', '#898A8C']
  //     domain: ['#392E7D', '#9D264A', '#E02028', '#E74D51', '#E56E25', '#EA8A50', '#EEB31D', '#F2C249', '#8881B0', '#615997']
  //   }
  // }

  colorScheme = {
    domain: ['#392E7D', '#e87f2a', '#E02028']
  }
  // pnoteChartOption: any = {
  //   showXAxis: true,
  //   showYAxis: true,
  //   gradient: false,
  //   showLegend: true,
  //   showXAxisLabel: true,
  //   xAxisLabel: 'Month',
  //   showYAxisLabel: true,
  //   yAxisLabel: 'Date of Month',
  //   animations: true
  // };

  // view: [number, number] = [800, 300];
  // gradient: boolean = true;
  // showLegend: boolean = true;
  // showLabels: boolean = true;
  // isDoughnut: boolean = false;
  // legendPosistion: string = 'right';
  // tradeDetailsColorScheme = {
  //   name: 'pieChart',
  //   selectable: true,
  //   // group: ScaleType.Ordinal,
  //   // domain: ['#392E7D', '#615997', '#8881B0', '#AFAACA', '#D8D4E4', '#E1E1E1', '#C5C4C4', '#A6A7A8', '#898A8C']
  //   domain: ['#392E7D', '#9D264A', '#E02028', '#E74D51', '#E56E25', '#EA8A50', '#EEB31D', '#F2C249', '#8881B0', '#615997']
  // }

  currentDateTime: Date = new Date();
  currentStageIndex: number;
  itemsPerSlide = 5;

  @HostListener("window:resize", []) updateItemsPerSlide() {
    if (window.innerWidth >= 1400) {
      this.itemsPerSlide = 5;
    } else if (window.innerWidth >= 1200) {
      this.itemsPerSlide = 4;
    } else if (window.innerWidth >= 992) {
      this.itemsPerSlide = 3;
    } else if (window.innerWidth >= 768) {
      this.itemsPerSlide = 2;
    } else if (window.innerWidth < 768) {
      this.itemsPerSlide = 1
    }
    this.cdref.detectChanges();
  }

  constructor(private userDetailsService: UserDetailsService,
    // private rateDerivativeService: RateDerivativesService,
    private pnoteSrevice: PNoteService,
    // private fsService: ForexDerivativesService,
    private spinner: NgxSpinnerService,
    private toastr: ToastrService,
    private cdref: ChangeDetectorRef,
    private appService: AppService) { }


  ngOnInit(): void {

    this.getUserDetailsDashboard();
    this.userDetails = this.userDetailsService.getUserDetails();
    this.entityType = this.userDetails?.entityType;
    this.entityCode = this.userDetails?.entityCode;
    // this.getMemberData();
    this.updateItemsPerSlide();
    this.cdref.detectChanges();
    $('.selectpicker').selectpicker('refresh');

  }

  // for navtab
  selectedTab: any = [];
  selectTab(data: any) {
    this.selectedTab = data;
  }
  // end


  getUserDetailsDashboard() {
    this.userDetailsService.getUserDetailsDashboard().pipe(
      catchError((error: any) => {
        if (error.status != 200) {
          return throwError(error.error);
        }
      })
    ).subscribe((response: any) => {
      if (response.statusCode == 200) {
        this.userDetailsService.setUserDetails(response.data && response.data[0]);
        this.user = response.data[0];
        if (this.user.entityType == "MEMBER") {
          this.checkUserAccess();
        }
      }
    });
  }
  //for carausal
  currentSlide = 0;

  next() {
    if (this.currentIndex < this.user?.menusList.length - this.itemsPerPage) {
      this.currentIndex += this.itemsPerPage;
    }
  }

  previous() {
    if (this.currentIndex > 0) {
      this.currentIndex -= this.itemsPerPage;
    }
  }


  checkUserAccess() {
    // if (!this.userDetails)
    //   this.userDetails = JSON.parse(localStorage.getItem('userDetails'));
    this.config.dashboardMenu.forEach(dMenu => {

      let menu = this.user.menusList.filter(menu => (menu.menuCode == dMenu));
      if (menu.length == 0) {
        this.user.menusList.forEach(element => {
          if (element.userMenusImpls) {
            let menu1 = element.userMenusImpls.filter(submenu => (submenu.menuCode == dMenu));
            menu.push(...menu1);
            element.userMenusImpls.forEach(element1 => {
              if (element1.userMenusImpls) {
                let menu1 = element1.userMenusImpls.filter(submenu => (submenu.menuCode == dMenu));
                menu.push(...menu1);
              }
            })
          }
        });
      }
      if (menu[0]?.isAccessAllowed === 'Y') {
        this.dashboardView.push(menu[0]);
        this.selectedTab = this.dashboardView[0];

        this.getChartData(menu[0].menuCode, this.entityCode);
      }
      return menu[0];
    });

  }

  getChartData(menuCode: string, entityCode: any) {
    switch (menuCode) {
      case "pnote":
        this.getPnoteTradeDataChart(entityCode);
        break;
      case "interestRateSwap":
        // this.getirsTradeDataChart(entityCode);
        break;
      default:
        break;
    }
  }
  //For Chart data
  // getirsTradeDataChart(entityCode: any) {
  //   this.tradeData = [];
  //   this.rateDerivativeService.getirsTradeDataChart(entityCode).pipe(
  //     catchError((error: any) => {
  //       if (error.status != 200) {
  //         this.tradeData = [];
  //         return throwError(error.error);
  //       }
  //     })
  //   ).subscribe((response: any) => {
  //     if (response.statusCode == 200) {
  //       let data = response.data;
  //       this.tradeData = data;
  //     }
  //   });
  // }

  getPnoteTradeDataChart(entityCode: any) {
    this.pnoteChartData = [];
    entityCode = this.entityType == "ADMIN" ? this.selectedMember : entityCode;
    this.pnoteSrevice.getPnoteTradeDataChart(this.crntYear, entityCode).pipe(
      catchError((error: any) => {
        if (error.status != 200) {
          this.tradeData = [];
          return throwError(error.error);
        }
      })
    ).subscribe((response: any) => {
      if (response.statusCode == 200) {
        let data = response.data;
        this.pnoteChartData = data;
      }
    });

  }

  // for selection of member

  // getMemberData() {
  //   this.fsService.getCounterPartyListInterbank().pipe(
  //     catchError((error: any) => {
  //       this.spinner.hide();
  //       if (error.statusCode != 200) {
  //         this.toastr.error(error.message);
  //       }
  //       return throwError(error.error)
  //     })
  //   ).subscribe((response: any) => {
  //     if (response.statusCode == 200) {
  //       this.memberData = response.data;
  //       this.cdref.detectChanges();
  //       $('.selectpicker').selectpicker('refresh');
  //     }


  //   })

  // }

  selectMember() {
    let memberData = this.memberData.find(data => data.entityCode == this.selectedMember)
    this.selectedMember = memberData.entityCode;

  }


  getMemberDetailsDashboard() {
    this.spinner.show();
    let memberData = this.memberData.find(data => data.entityCode == this.selectedMember)
    this.selectedMember = memberData.entityCode;
    this.dashboardView = [];
    this.appService.getUserDetails(memberData.userId).pipe(
      catchError((error: any) => {
        if (error.status != 200) {
          this.spinner.hide();
          return throwError(error.error);
        }
      })

    ).subscribe((response: any) => {
      if (response.statusCode == 200) {
        // this.userDetailsService.setUserDetails(response.data && response.data[0]);
        let userMem = response.data[0];
        this.config.dashboardMenu.forEach(dMenu => {

          let menuMem = userMem.menusList.filter(menu => (menu.menuCode == dMenu));
          if (menuMem.length == 0) {
            userMem.menusList.forEach(element => {
              if (element.userMenusImpls) {
                let menu1 = element.userMenusImpls.filter(submenu => (submenu.menuCode == dMenu));
                menuMem.push(...menu1);
                element.userMenusImpls.forEach(element1 => {
                  if (element1.userMenusImpls) {
                    let menu1 = element1.userMenusImpls.filter(submenu => (submenu.menuCode == dMenu));
                    menuMem.push(...menu1);
                  }
                })
              }
            });
          }
          if (menuMem[0].isAccessAllowed === 'Y') {
            this.dashboardView.push(menuMem[0]);
            this.selectedTab = this.dashboardView[0];
            this.getChartData(menuMem[0].menuCode, this.selectedMember)
          }
          return menuMem[0];
        });
      }
      this.spinner.hide();
    });
  }
}



